import { QueryOptions } from '@shared/fetch-utils';
import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { useAuthContext } from '@retail/auth/data-access';
import { useMPEFetch } from '@retail/app/hooks';
import { SupplierDTO } from '@retail/suppliers/types';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';

export interface SuppliersSearchParams {
  assortmentId?: number;
  includeConfiguration?: boolean;
}

export function useFetchAllSuppliers(
  searchParams?: SuppliersSearchParams,
  queryOptions: QueryOptions = {}
) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();

  return useMPEFetch<SupplierDTO[]>({
    method: 'GET',
    queryKey: ['suppliers', searchParams],
    token,
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.suppliers.getFullLinkPath(),
      searchParams: {
        ...searchParams,
      },
    }),
    ...queryOptions,
  });
}
